import { render, staticRenderFns } from "./leadDetail.vue?vue&type=template&id=ac6ed6ec&lang=pug"
import script from "./leadDetail.vue?vue&type=script&lang=js"
export * from "./leadDetail.vue?vue&type=script&lang=js"
import style0 from "./leadDetail.vue?vue&type=style&index=0&id=ac6ed6ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports